import React, { createContext, useContext } from 'react';

type SharedStateType = {
  state: number;
  setState: React.Dispatch<React.SetStateAction<number>>;
};

export const ScrollableFiltersContext = createContext<SharedStateType | undefined>(undefined);

export const useSharedState = () => {
  return useContext(ScrollableFiltersContext);
};